module.exports = __webpack_public_path__ + "img/mkt_sale.e756eba3.svg";